import {LsdApiTranslatableModel} from './global/LsdApiTranslatableModel';
import { computed }              from 'mobx';

export default class GroupLsdModel extends LsdApiTranslatableModel {
	static get path(): string {
		return '/groups/{?id}';
	}

	@computed
	public get reference() {
		return this.get('reference');
	}
}
